export function XML_Cmd2(theCmd, param1, param2, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementTriple("cm", theCmd, param1, param2, s);
}
